import React, { useEffect } from "react"
import Section from "../Common/Section"
import { AnimatePresence, motion } from 'framer-motion'
import { Button } from 'react-bootstrap'
import { Link } from "react-router-dom"
import Typewriter from 'typewriter-effect/dist/core';

import "./Home.css"

import video from '../../assets/aqua_home.mp4'
import { Helmet } from "react-helmet"

export default function Home() {

  useEffect(() => {
    var typewriter = document.getElementById('typewriter');

    if(typewriter) {
      new Typewriter(typewriter, {
        strings: ['serenity.', 'luxury.', 'elegance.', 'comfort.', 'home.'],
        pauseFor: 2500,
        loop: true,
        autoStart: true,
        delay: 'natural'
      });
    }
  }, [])

  return (
    <Section id="home">
      <Helmet>
          <meta charSet="utf-8" />
          <title>Aqua Bayonne | Bayonne Apartments | 54 Flagship St.</title>
          <meta name="description" content="Bayonne apartments for rent with waterfront views and premium amenities at Aqua Bayonne."/>
      </Helmet>
      <div className="home-container">
        <AnimatePresence>
          <motion.div className="home-video-container">
            <div className="home-video-wrapper">
              <video className="home-video" autoPlay loop muted playsInline>
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="home-overlay"></div>
            </div>
            <motion.div
              className="home-overlay-text"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1.5 }}
            >
              <h1 className="home-text">AQUA is</h1>
              <div id="typewriter"></div>
              <h6 className="d-none d-xl-block home-text home-text-desktop" style={{ fontSize: '1rem', fontWeight: 700 }}>
                Bayonne Apartments for rent available now! Visit us to find your new home!
              </h6>
              <h6 className="d-xl-none home-text home-text-mobile" style={{ fontSize: '1rem', fontWeight: 700 }}>
                Bayonne Apartments for rent only
              </h6>
              <Link to="/inquire" className="book-tour-link" >
                <Button className="book-tour-home-btn">Book A Tour</Button>
              </Link>
              <Link to="/contact-us" className="contact-us-link">
                <Button className="contact-us-home-btn">Contact Us</Button>
              </Link>
              <Link to="/residences" className="contact-us-link">
                <Button className="contact-us-home-btn">Residences</Button>
              </Link>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      </div>
    </Section>
  )
}

